<template>
  <div class="plugin-container">
    <keep-alive>
      <component 
        :is="currentComponent" 
        :chatData="selectedChatData"
        :friendData="selectedFriendData"
        @showChat="showChatView"
        @showFriend="showFriendView"
        @backToInbox="backToInbox"
        ref="currentComponentRef"
      />
    </keep-alive>
  </div>
</template>

<script>
import InboxPlugin from "./InboxPlugin.vue";
import PluginChat from "./PluginChat.vue";

export default {
  name: "Plugin",
  components: {
    InboxPlugin,
    PluginChat
  },
  data() {
    return {
      currentView: 'inbox', // 当前显示的视图: 'inbox' | 'chat' | 'friend'
      selectedChatData: null, // 选中的聊天数据
      selectedFriendData: null, // 选中的好友数据
    };
  },
  computed: {
    currentComponent() {
      if (this.currentView === 'inbox') {
        return 'InboxPlugin';
      } else {
        return 'PluginChat';
      }
    }
  },
  methods: {
    // 显示聊天视图
    showChatView(chatData) {
      console.log('切换到聊天视图:', chatData);
      this.selectedChatData = chatData;
      this.selectedFriendData = null;
      this.currentView = 'chat';
    },
    
    // 显示好友详情视图
    showFriendView(friendData) {
      console.log('切换到好友详情视图:', friendData);
      this.selectedFriendData = friendData;
      this.selectedChatData = null;
      this.currentView = 'friend';
    },
    
    // 回退到收件箱视图
    backToInbox() {
      console.log('回退到收件箱视图');
      this.currentView = 'inbox';
      this.selectedChatData = null;
      this.selectedFriendData = null;
    }
  },
  
  // 组件创建时默认显示收件箱
  created() {
    console.log('Plugin组件已创建，默认显示收件箱');
  }
};
</script>

<style lang="scss" scoped>
.plugin-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>
